import { config } from '@config'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useCallback, useState } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { RouterProvider } from 'react-router-dom'
import { useEffectOnce } from 'react-use'

import AppErrorBoundaryFallback from '@/common/AppErrorBoundaryFallback'
import { ThemeProvider } from '@/contexts/ThemeProvider'
import { TransactionProvider } from '@/contexts/TransactionProvider'
import { Web3ContextProvider } from '@/contexts/Web3Provider'
import { ErrorHandler } from '@/helpers'
import { createRouter } from '@/routes'

const router = createRouter()
const queryClient = new QueryClient()

export function App() {
  const [isAppInitialized, setIsAppInitialized] = useState(false)

  const init = useCallback(async () => {
    try {
      if (config.VITE_APP_NAME) {
        document.title = config.VITE_APP_NAME
      }
    } catch (error) {
      ErrorHandler.processWithoutFeedback(error)
    }

    setIsAppInitialized(true)
  }, [])

  useEffectOnce(() => {
    init()
  })

  if (!isAppInitialized) return null

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <ErrorBoundary
          FallbackComponent={({ resetErrorBoundary }) => (
            <AppErrorBoundaryFallback onReset={resetErrorBoundary} />
          )}
          onReset={() => window.location.reload()}
        >
          <Web3ContextProvider>
            <TransactionProvider>
              <RouterProvider router={router} />
            </TransactionProvider>
          </Web3ContextProvider>
        </ErrorBoundary>
      </ThemeProvider>
    </QueryClientProvider>
  )
}
